module.exports = __webpack_public_path__ + "static/media/brinquedo6.f76c097b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brinquedo6.jpg
// module id = 62
// module chunks = 0